import Vue from 'vue';
import { library } from '@fortawesome/fontawesome-svg-core';
// import { far } from '@fortawesome/free-regular-svg-icons';

import {
	faUser
} from '@fortawesome/free-solid-svg-icons';

library.add(faUser);